export class SessionTimerConfig {
  title: string;
  beforeTimerText: string;
  afterTimerText: string;
  shownWithSecondsRemaining: number;

  constructor(
    config: {
      title?: string;
      beforeTimerText?: string;
      afterTimerText?: string;
      timer?: number;
    } = {},
  ) {
    this.title = config.title || 'Extend Your Session';
    this.beforeTimerText =
      config.beforeTimerText || 'Your current session will expire in ';
    this.afterTimerText =
      config.afterTimerText || '. You can extend your session or logout.';
    this.shownWithSecondsRemaining = config.timer || 30;
  }
}

export interface SessionTimerArgs {
  isLoggedIn: boolean;
  sessionAge: number;
}
